import { CloseRounded, Delete } from '@mui/icons-material'
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { CancelButton, DeleteButton } from '../../../../shared/components/inputs'
import { StyledDialog } from '../../../../shared/styles/StyledDialog'

interface DeleteLineDialogProps {
  open: boolean
  onClose: () => void
  onDelete: () => void
  t: (key: string) => string
}

export const DeleteLineDialog = ({ open, onClose, onDelete }: DeleteLineDialogProps) => {
  const { t } = useTranslation(['global'])

  return (
    <StyledDialog open={open} onClose={onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
      <DialogTitle id="alert-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">
            {t('delete')} {t('line')}
          </Typography>
          <Button onClick={onClose} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ pb: 3, pt: 2 }}>
        <Grid container alignItems="flex-start" spacing={2}>
          <Grid item xs={12}>
            <Typography> {t('confirm-delete')} </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={onClose}>{t('cancel')}</CancelButton>
        <DeleteButton startIcon={<Delete />} onClick={onDelete}>
          {t('delete')}
        </DeleteButton>
      </DialogActions>
    </StyledDialog>
  )
}
